import React, { ReactNode, useEffect } from "react";
import cx from "classnames";
import { useContext } from "react";
import ProgressBar from "../../common/components/ProgressBar/ProgressBar";
import MobileNavMulticompare from "../../compare/components/MobileNavMulticompare/MobileNavMulticompare";
import useAFForm from "../hooks/useAFForm";
import { AppFormControllerContext } from "../providers/AppFormProvider";
import AFErrorDialog from "./AFErrorDialog";
import AFSidebar from "./AFSidebar";
import { PageType } from "../enums/PageType";

interface ILayout {
    children: ReactNode;
    isInErrorState: boolean;
    currentPage: PageType;
    applicantParam?: string;
}

const AFLayout: React.FC<ILayout> = ({children, isInErrorState, currentPage, applicantParam = "" }: ILayout) => {
    const { selectors } = useContext(AppFormControllerContext);
    const { populateDataLayer } = useAFForm();

    useEffect(() => {
        populateDataLayer(selectors.getApplicationId(), selectors.getQuoteGroupId());
    }, []);

    return (
        <>
            <div className={cx("panel-header-bar")}></div>
            {isInErrorState && <AFErrorDialog/>}
            <MobileNavMulticompare />
            <div className={cx("layout-appform-page")}>
                <AFSidebar currentPage={currentPage} applicantParam={applicantParam} />
                <div className={cx("panel-appform-content")}>{children}</div>
            </div>
        </>
    );
};

export default AFLayout;
